import React from 'react'
import injectSheet from 'react-jss'
import { Modal, ModalHeader, ModalContent } from 'pobble-components/dist/modal'
import ImageSelector from '../../../image-selector/image-selector.container'
import { useDispatch, useSelector } from 'react-redux'
import {
  getCreateSlideRequest,
  getPresentation
} from '../../../../stores/presentation/presentation.selectors'
import {
  apiCreateSlide,
  apiUpdateSlide,
  apiUploadImage
} from '../../../../common/api/lesson'
import { errorHandler } from 'pobble-components/dist/error-handler'
import { createSlide } from '../../../../stores/presentation/presentation.actions'
import { getCreateSlideDialog } from '../../../pages/lesson/builder/redux/builder.selectors'
import { closeCreateSlideDialog } from '../../../pages/lesson/builder/redux/builder.actions'
import PendingArea from '../../../pending-area/pending-area'

const styles = {
  formHolder: {
    flex: '1'
  },
  previewHolder: {
    width: '124px',
    marginLeft: '20px',
    height: '124px'
  },
  content: {
    position: 'relative'
  },
  pending: {
    position: 'absolute',
    left: '0',
    top: '0',
    zIndex: '100',
    background: 'rgba(255,255,255,.7)'
  }
}

const ImageSlideCreateDialog = ({
  classes,
  onChange,
  onClose,
  onSubmit,
  onLinkChange,
  disableSubmit
}) => {
  const dispatch = useDispatch()
  const presentation = useSelector(getPresentation)
  const createSlideDialog = useSelector(getCreateSlideDialog)
  const request = useSelector(getCreateSlideRequest)
  const modalOpened =
    createSlideDialog.opened && createSlideDialog.type === 'Image'

  const createImageSlide = uploadImage => {
    dispatch(
      createSlide({ type: 'Image' }, ({ order }) => () => {
        return apiCreateSlide(presentation.id, {
          type: 'Image',
          imagePosition: 'center',
          image_size: 'fill',
          order
        })
          .then(createSlideRes => {
            const slide = createSlideRes.data.slide
            return uploadImage(slide).then(res => {
              /**
               * Redux relies on the data response from create slide endpoint
               *   so we extend this data with the newly uploaded image
               */
              createSlideRes.data.slide = res.data.slide
              return createSlideRes
            })
          })
          .catch(errorHandler)
      })
    )
  }

  return (
    <Modal
      closeButton
      isOpen={modalOpened}
      requestClose={() => dispatch(closeCreateSlideDialog())}>
      <ModalHeader>Select an image</ModalHeader>
      <ModalContent className={classes.content}>
        {request.pending && <PendingArea className={classes.pending} />}
        <ImageSelector
          defaultSearchValue={presentation.title}
          onFileSelect={files => {
            createImageSlide(slide => {
              return apiUploadImage(
                slide.id,
                {
                  image: files[0]
                },
                {
                  include: 'slide.type,slide.details'
                }
              )
            })
          }}
          onUnsplashSelect={unsplashId => {
            createImageSlide(slide => {
              return apiUploadImage(
                slide.id,
                {
                  unsplash_id: unsplashId
                },
                {
                  include: 'slide.type,slide.details'
                }
              )
            })
          }}
          onMainImageSelect={e => {
            createImageSlide(slide => {
              return apiUpdateSlide(
                slide.id,
                {
                  use_presentation_image: true
                },
                {
                  include: 'slide.type,slide.details'
                }
              )
            })
          }}
        />
      </ModalContent>
    </Modal>
  )
}

export default injectSheet(styles)(ImageSlideCreateDialog)
